import React from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import DynamicFormControls from "./DynamicFormControls";
import Loading from '../../helper/component/Loading';
import * as formsAction from "../actions";
import ControlService from '../../helper/controlservice';
import { Tabs, Tab } from "react-bootstrap";
import exportToCSV from "../../helper/exportToCsv"
import ImportUI from '../Import-ui';
import Facet from "../../helper/component/Facet"
import { renderSearchBox, renderFilterControls } from '../../helper/common/searchFilter';

function bindAction(dispatch) {
    return {
        resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
        resetFilter: (data) => dispatch(formsAction.resetFilterData(data)),
        resetEditData: (data) => dispatch(formsAction.resetEditFormData(data)),
        resetParentCtr: (data) => dispatch(formsAction.resetParentCtrdata(data)),
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
        updateFilter: (key, value, key2 = '') => dispatch(formsAction.updateFilterData(key, value, key2)),
        updateEditForm: (key, value) => dispatch(formsAction.updateEditData(key, value)),
        resetSidebar: (data) => dispatch(formsAction.resetSidebar(data)),
        setSidebarFormId: (data) => dispatch(formsAction.setSidebarFormId(data)),
        setPageParams: (data) => dispatch(formsAction.setPageParams(data)),
        setreload: (bool) => dispatch(formsAction.setreload(bool)),
        resetRealTimeSync: (bool) => dispatch(formsAction.resetRealTimeSync(bool)),
        dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    reload: state.formDataReducer.reload,
    isSidebarOpened: state.formDataReducer.isSidebarOpened,
    realtimeSync: state.formDataReducer.realtimeSync
});


class DynamicForm extends React.PureComponent {
    state = {
        uiSchema: {},
        controls: [],
        action: '',
        FilterUIJson: {},
        FilterTrayOpen: false,
        isApiCalling: false,

        filterCount: 0,
        customFilterFormUI: null,
        selectedTabKey: 0,
        refreshPage: false
    }
    constructor(props) {
        super(props);
    }
    static getDerivedStateFromProps(nextProps) {
        const uiSchema = "uiSchema" in nextProps ? nextProps.uiSchema : {};
        const controls = uiSchema.controls ? uiSchema.controls : [];
        const action = nextProps.action ? nextProps.action : 'write';
        const FilterUIJson = uiSchema.FilterUIJson ? uiSchema.FilterUIJson : { FilterEndpointParams: [], controls: [] };
        //const FilterTrayOpen = false;
        //const realtimeSync = false;
        return {
            uiSchema: uiSchema,
            controls: controls,
            action: action,
            FilterUIJson: FilterUIJson,
            //FilterTrayOpen: FilterTrayOpen,
            //realtimeSync: realtimeSync,
            refreshPage: nextProps.reload
        };
    }
    async componentDidUpdate(prevProps, prevState) {
        var realtime = this.state.FilterUIJson.CustomFilter && this.state.customFilterFormUI ? this.state.customFilterFormUI.realtime : this.state.FilterUIJson.realtime;
        if (!realtime && typeof this.state.refreshPage == 'object' && this.state.refreshPage.refresh == true && this.state.uiSchema && this.state.refreshPage.activeformid != (this.state.uiSchema.Id + this.state.action) && this.props.action == "filter") {
            this.props.setreload(false);
            var datamodel = this.state.uiSchema.ModelJson;
            ControlService().GenerateDataJson(this.state.uiSchema.controls ? this.state.uiSchema.controls : [], datamodel, null, true);
            this.props.resetData(datamodel, this.props.formid + this.props.action);
            this.state.FilterUIJson.CustomFilter ? this.loadCustomFilterForm() : this.search()
        }
        if (this.state.FilterUIJson.enableshoppingcart && this.props.isSidebarOpened === false && prevProps.isSidebarOpened === true) {
            await this.FetchCartCount();
        }
    }
    // Allow children to use context
    getChildContext() {
        return {
            editFormId: this.state.FilterUIJson.filterAddform
        };
    }
    GenerateDataJson(modelJson, data) {
        if (data) {
            Object.keys(modelJson).forEach(key => {
                this.props.updateEdit(key, data[key]);
            })
        } else {
            Object.keys(modelJson).forEach(key => {
                this.props.update(key, modelJson[key]);
            })
        }
    }
    componentDidMount() {
        if (this.state.uiSchema && (this.state.action == 'filter' || this.state.FilterUIJson.CustomFilter) && !this.searchCalled) {
            this.state.FilterUIJson.CustomFilter ? this.loadCustomFilterForm() : this.search()
        }
    }
    InitializeAddForm() {

        if (this.state.FilterUIJson.actiontype && this.state.FilterUIJson.actiontype == "redirect") {
            this.context.history.push(this.state.FilterUIJson.redirecturl);
        } else {
            this.props.resetData({}, this.state.FilterUIJson.filterAddform + "write");
            this.props.setPageParams("AddNew");
            this.props.resetSidebar(!this.props.isSidebarOpened);
            this.props.setSidebarFormId(this.state.FilterUIJson.filterAddform);
        }
    }
    handleFilterTrayOpen(value) {

        this.setState({ FilterTrayOpen: value })
        this.props.resetFilter(this.props.uiSchema.FilterModelJson);
        // if (this.state.uiSchema.FilterUIJson && this.state.uiSchema.FilterUIJson.CustomFilter && !this.state.customFilterFormUI) {
        //     this.loadCustomFilterForm()
        // }
    }
    handleCartTrayOpen() {
        const { FilterUIJson } = this.state;
        debugger;
        if (FilterUIJson.CartActionType === 'sidebar') {
            ControlService().SetParamUrl(FilterUIJson.cartPrimaryKey, this.props.data[FilterUIJson.cartPrimaryKey]);

            this.props.resetSidebar(!this.props.isSidebarOpened);
            this.props.setSidebarFormId(FilterUIJson.cartsidebarformid);
        } else if (FilterUIJson.cartRedirectUrl && FilterUIJson.CartActionType === 'sametab') {
            if (FilterUIJson.cartPrimaryKey) {
                let path = FilterUIJson.cartRedirectUrl + "?" + FilterUIJson.cartPrimaryKey + '=' + this.props.data[FilterUIJson.cartPrimaryKey];
                this.context.history.push(path);
            } else {
                let path = FilterUIJson.cartRedirectUrl;
                this.context.history.push(path);
            }
        } else if (FilterUIJson.cartRedirectUrl && FilterUIJson.CartActionType === 'newtab') {
            if (FilterUIJson.cartPrimaryKey) {
                let path = FilterUIJson.cartRedirectUrl + "?" + FilterUIJson.cartPrimaryKey + '=' + this.props.data[FilterUIJson.cartPrimaryKey];
                window.open(path, '_blank');

            } else {
                let path = FilterUIJson.cartRedirectUrl;
                window.open(path, '_blank');
            }
        }
    }
    loadCustomFilterForm() {
        const formid = this.state.uiSchema.FilterUIJson.customfilterapimappingform;
        if (formid) {
            if (this.state.uiSchema.FilterUIJson && this.state.uiSchema.FilterUIJson.CustomFilter && !this.state.customFilterFormUI) {
                this.setState({ isApiCalling: true });


                ControlService().loadMetadata(formid, this.props.token)
                    .then((data) => {
                        this.props.resetData(data.ModelJson, data.Id + "write")
                        this.setState({
                            customFilterFormUI: data,
                            isApiCalling: false
                        }, () => this.customSearch());
                    })
                    .catch(err => {
                        this.setState({
                            customFilterFormUI: null,
                            isApiCalling: false
                        });
                        console.log(err);
                    });
            } else {
                this.customSearch()
            }
        }
    }
    async FetchCartCount() {
        const { FilterUIJson } = this.state;
        this.setState({ cartCount: 0 })
        var apiParam = {};
        FilterUIJson.cartapiparam.forEach(option => {
            apiParam[option.key] = option.value;
        })
        let _control = ControlService().extractControl(control, 'cart');
        // AsyncStorage.getItem(settings.TOKEN, (err, result) => {
        await ControlService().ServiceRequest(FilterUIJson.cartApi, apiParam, _control, this.props.token, null)
            .then(res => {
                this.setState({ cartCount: res[FilterUIJson.cartapifieldforresponse] })
            })
            .catch(err => {
                this.setState({ cartCount: 0 })
                console.log(err);
            });
    }
    searchFacet = (e) => {
        debugger;
        this.state.FilterUIJson.CustomFilter ? this.customSearch(false, e) : this.search(false, e);
    }
    search(isExport, selectedFacet) {
        const { FilterUIJson } = this.state;
        if (FilterUIJson.enableshoppingcart && !selectedFacet) {
            this.FetchCartCount();
        }
        if (this.props.realtimeSync) {
            this.props.resetRealTimeSync(false);
        }
        var dataModel = {};
        var data = this.props.data[this.props.uiSchema.Id + 'write'] ? this.props.data[this.props.uiSchema.Id + 'write'] : {};

        this.setState({ filterCount: (this.props.filterdata ? this.setfilterCount() : 0), FilterTrayOpen: false })
        var apiParam = {};
        FilterUIJson.FilterEndpointParams.forEach(option => {
            if (option.key == "query") {
                apiParam[option.key] = this.props.filterdata ? JSON.stringify(this.props.filterdata) : '';
            } else if (option.value === 'searchfilterbox') {
                apiParam[option.key] = data[option.value];
            } else {
                apiParam[option.key] = option.value;
            }
        })

        if (FilterUIJson.enablefacet) {
            dataModel = ControlService().createFacetRequst(data, FilterUIJson, selectedFacet);
        } else if (FilterUIJson.FilterRawQuery) {
            var query = FilterUIJson.FilterRawQuery;

            FilterUIJson.FilterEndpointParams.forEach(option => {
                var value = option.value;
                var paramVal = ControlService().GetParamUrl(option.value)
                if (paramVal) {
                    value = paramVal;
                }
                var param = "{{" + option.key + "}}";
                query = query.replace(param, value)
                // query.replace(param, value)

            })
            apiParam.query = query;

            dataModel = query;
        } else {
            dataModel = data;
        }
        this.setState({ realtimeSync: false });
        var filterResultCtr = this.state.controls.filter(x => x.filterresult == true);
        // AsyncStorage.getItem(settings.TOKEN, (err, result) => {
        if (filterResultCtr.length > 0) {
            this.props.dataIsLoading(true);
            FilterUIJson.id = []
            filterResultCtr.map(ctr => {
                localStorage.removeItem(ctr.id + 'watermark');
                FilterUIJson.id.push(ctr.id);
            });
            const _control = ControlService().extractControl(FilterUIJson, "filter");
            ControlService().ServiceRequest(FilterUIJson.FilterApiEndpoint, apiParam, _control, this.props.token, dataModel)
                .then(res => {
                    if (FilterUIJson.enablefacet && FilterUIJson.facetresponsefield) {
                        this.setState({ facetData: res && res[FilterUIJson.facetresponsefield] ? res[FilterUIJson.facetresponsefield] : {} });
                    }
                    this.props.dataIsLoading(false);
                    this.setSearchResponse(res, isExport, filterResultCtr, apiParam, FilterUIJson.FilterApiEndpoint);
                })
                .catch(err => {
                    this.props.dataIsLoading(false);
                    console.log(err);
                });
        } else {
            this.setState({ FilterTrayOpen: false });
        }
        // });
    }
    setSearchResponse(res, isExport, filterResultCtr, apiparam, url) {
        const { FilterUIJson, uiSchema } = this.state
        if (FilterUIJson.responsefield) {
            res = res[FilterUIJson.responsefield];
        }
        else {
            res = res && Array.isArray(res) ? res : [];
        }
        if (isExport) {
            exportToCSV().generatecsvReport(FilterUIJson.ExportColumns, res, uiSchema.Formname);
        }
        else {
            filterResultCtr.forEach(item => {
                this.props.update(item.key, res, uiSchema.Id + this.props.action);
                this.props.update(item.key + '_filterParam', { "apiurl": url, "params": apiparam }, uiSchema.Id + this.props.action);
            });
        }
    }

    customSearch(isExport, selectedFacet) {
        debugger;
        var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {}
        var dataModel = {};
        if (this.props.realtimeSync) {
            this.props.resetRealTimeSync(false);
        }
        var apiparam = {};
        const { uiSchema } = this.props;
        if (this.props.action !== 'filter') {
            ControlService().GenerateDataJson(uiSchema.controls ? uiSchema.controls : [], uiSchema.ModelJson);
            this.props.resetData(uiSchema.ModelJson, uiSchema.Id + this.props.action);
        }
        var customFilterUI = this.state.customFilterFormUI ? this.state.customFilterFormUI.FilterUIJson : null;

        if (uiSchema.FilterUIJson.enableshoppingcart && !selectedFacet) {
            this.FetchCartCount();
        }
        if (uiSchema && customFilterUI) {
            this.props.dataIsLoading(true);
            this.setState({ FilterTrayOpen: false })
            var filterResultCtr = uiSchema.controls.filter(x => x.filterresult == true);
            customFilterUI.id = []
            filterResultCtr.map(ctr => {
                localStorage.removeItem(ctr.id + 'watermark');
                customFilterUI.id.push(ctr.id);
            })
            customFilterUI.FilterEndpointParams.forEach(option => {
                if (option.value === 'searchfilterbox') {
                    apiparam[option.key] = data[option.value];
                } else {
                    apiparam[option.key] = option.value;
                }
            })

            var customFilterFormModel = this.props.data[this.state.customFilterFormUI.Id + "write"] ? this.props.data[this.state.customFilterFormUI.Id + "write"] : {}
            uiSchema.FilterUIJson.customfilterapimapping.forEach(item => {
                apiparam[item.ApiParam] = customFilterFormModel[item.customfilterfield] == "undefined" ? "" : customFilterFormModel[item.customfilterfield];
            })

            let url = customFilterUI.FilterApiEndpoint;
            if (uiSchema.FilterUIJson.enablefacet) {
                var _data = this.props.data[this.props.uiSchema.Id + 'write'] ? this.props.data[this.props.uiSchema.Id + 'write'] : {};
                dataModel = ControlService().createFacetRequst(_data, uiSchema.FilterUIJson, selectedFacet);
            } else if (uiSchema.FilterUIJson.FilterRawQuery) {
                var query = uiSchema.FilterUIJson.FilterRawQuery;

                uiSchema.FilterUIJson.FilterEndpointParams.forEach(option => {
                    var value = option.value;
                    var paramVal = ControlService().GetParamUrl(option.value)
                    if (paramVal) {
                        value = paramVal;
                    }
                    var param = "{{" + option.key + "}}";
                    query = query.replace(param, value)
                    // query.replace(param, value)

                })
                apiparam.query = query;
                dataModel = query;
            }
            const _control = ControlService().extractControl(customFilterUI, "filter");
            ControlService().ServiceRequest(url, apiparam, _control, this.props.token, dataModel, null, null, this.setCustomSearchResult.bind(this))
                .then((res) => {
                    this.props.dataIsLoading(false);
                    var result = null;
                    if (customFilterUI.responsefield) {
                        result = res[customFilterUI.responsefield];
                    }
                    else {
                        result = res && Array.isArray(res) ? res : [];
                    }
                    if (uiSchema.FilterUIJson.enablefacet && uiSchema.FilterUIJson.facetresponsefield) {
                        this.setState({ facetData: res && res[uiSchema.FilterUIJson.facetresponsefield] ? res[uiSchema.FilterUIJson.facetresponsefield] : {} });
                    }
                    if (isExport) {
                        exportToCSV().generatecsvReport(this.state.FilterUIJson.ExportColumns, result, this.state.uiSchema.Formname)
                    } else {
                        if (this.props.action == 'filter') {
                            filterResultCtr.forEach(item => {
                                this.props.update(item.key, result, this.props.uiSchema.Id + this.props.action);
                                this.props.update(item.key + '_filterParam', { "apiurl": url, "params": apiparam }, this.props.uiSchema.Id + this.props.action);
                            });
                        } else {
                            this.props.resetData(result, uiSchema.Id + this.props.action);
                        }
                    }
                    this.setState({ filterCount: this.customFilterCount(), FilterTrayOpen: false });

                    this.handleFilterTrayOpen(false)
                })
                .catch(() => {
                    this.props.dataIsLoading(false);
                    this.setState({ FilterTrayOpen: false });
                });
        }
    }
    setCustomSearchResult(result) {

        var filterResultCtr = this.props.uiSchema.controls.filter(x => x.filterresult == true);
        filterResultCtr.forEach(item => {
            this.props.update(item.key, result, this.props.uiSchema.Id + this.props.action);
        });
    }

    customFilterCount() {
        var count = 0;
        const data = this.props.data[this.state.customFilterFormUI.Id + "write"];
        for (let item in data) {
            if ((!Array.isArray(data[item]) && data[item]) || (Array.isArray(data[item]) && data[item].length > 0)) {
                count = count + 1;
            }
        }
        return count;
    }
    setfilterCount() {

        var count = 0;
        if (Array.isArray(this.props.filterdata)) {
            this.props.filterdata.forEach(item => {
                if (item.type == 'daterange' && (item.value.from != '' || item.value.to != '')) {
                    count = count + 1;
                } else if (item.type == 'range' && (item.value.from != '' || item.value.to != '')) {
                    count = count + 1;
                } else if (item.type == 'terms' && item.value.length > 0) {
                    count = count + 1;
                } else if (item.type == 'term' && item.value != '')
                    count = count + 1;
                else if (item.type == 'number' && (item.value.from != '' || item.value.to != ''))
                    count = count + 1;
            })
        }
        return count;
    }
    clearcustomfilter = async () => {
        await this.props.resetData(this.state.customFilterFormUI.ModelJson, this.state.customFilterFormUI.Id + "write")
        this.customSearch()
    }
    clearFilter = async () => {

        if (this.props.uiSchema.FilterUIJson.CustomFilter) {
            var data = this.props.data[this.state.customFilterFormUI.Id + "write"] ? this.props.data[this.state.customFilterFormUI.Id + "write"] : {};
            for (let item in data) {
                if (Array.isArray(data[item])) {
                    await this.props.update(item, [], this.state.customFilterFormUI.Id + "write")
                } else if (data[item] === true || data[item] === false) {
                    await this.props.update(item, false, this.state.customFilterFormUI.Id + "write")
                } else {
                    await this.props.update(item, "", this.state.customFilterFormUI.Id + "write")
                }
            }
            this.customSearch();
        }
        else {
            this.props.filterdata.forEach(item => {
                if (item.type == 'range' || item.type == 'number' || item.type == 'daterange') {
                    this.props.updateFilter(item.id, "", 'from');
                    this.props.updateFilter(item.id, "", 'to');
                } else if (item.type == 'terms') {
                    this.props.updateFilter(item.id, []);
                }
                else if (item.type != 'search') {
                    this.props.updateFilter(item.id, "");
                }
            })

            this.search();
        }
        // this.setfilterCount();

    }
    renderFilterResult() {
        var controls = this.state.controls.filter(control => control.filterresult == true);
        const { FilterUIJson } = this.state;

        if (controls.length === 1) {
            return (
                FilterUIJson.enablefacet ?
                    <React.Fragment>
                    <div className='row'>
                        
                        {FilterUIJson.facetPosition === 'top' || FilterUIJson.facetPosition === 'left' ?
                        <div className={(FilterUIJson.facetPosition == 'top' ? 'col-12' : 'col-3')}>
                            <Facet control={this.state.FilterUIJson} facetData={this.state.facetData} search={this.searchFacet} />
                        </div>
                        :null
                        }                        
                        <div className={(FilterUIJson.facetPosition == 'top' ? 'col-12' : 'col-9')}>
                            <div className='row'>
                                <DynamicFormControls key={controls[0].id} formid={this.props.uiSchema.Id} control={controls[0]} action={this.state.action} />
                            </div>
                        </div>
                        {FilterUIJson.facetPosition == 'right' &&
                        <div className='col-3'>
                            <Facet control={this.state.FilterUIJson} facetData={this.state.facetData} search={this.searchFacet} />
                        </div>
                        }
                    </div>
                    </React.Fragment>
                    :
                    <div className='row'>
                        <DynamicFormControls key={controls[0].id} formid={this.props.uiSchema.Id} control={controls[0]} action={this.state.action} />
                    </div>
            );
        } else if (controls.length > 1) {
            var FilterResult = controls.map((control, index) => {
                return (
                    <Tab key={control.key} eventKey={index} title={this.renderFilterTabIcon(control.type)}>
                        <div className="row">
                            <DynamicFormControls key={control.id} formid={this.props.uiSchema.Id} control={control} action={this.state.action} />
                        </div>
                    </Tab>
                )
            })
            return (
                FilterUIJson.enablefacet ?
                <React.Fragment>
                    <div className='row'>
                    {FilterUIJson.facetPosition == 'top' || FilterUIJson.facetPosition == 'left' &&
                        <div className={(FilterUIJson.facetPosition == 'top' ? 'col-12' : 'col-3')}>
                            <Facet control={this.state.FilterUIJson} facetData={this.state.facetData} search={this.searchFacet} />
                        </div>
                        }                        
                        <div className={(FilterUIJson.facetPosition == 'top' ? 'col-12' : 'col-9')}>
                            <div className="tab-card mb-0 tab-filter">
                                <Tabs activeKey={this.state.selectedTabKey} animation="false"
                                    onSelect={(e) => { this.setState({ selectedTabKey: e }) }}
                                    id={this.props.uiSchema.Id}>{FilterResult}</Tabs>
                            </div>
                        </div>
                        {FilterUIJson.facetPosition == 'right' &&
                        <div className='col-3'>
                            <Facet control={this.state.FilterUIJson} facetData={this.state.facetData} search={this.searchFacet} />
                        </div>
                        }
                    </div>
                    </React.Fragment>
                    :
                    <div className="tab-card mb-0 tab-filter">
                        <Tabs activeKey={this.state.selectedTabKey} animation="false"
                            onSelect={(e) => { this.setState({ selectedTabKey: e }) }}
                            id={this.props.uiSchema.Id}>{FilterResult}</Tabs>
                    </div>
            );
        } else {
            return null;
        }
    }
    exportToCSV(FilterUIJson) {
        FilterUIJson.CustomFilter ? this.customSearch(true) : this.search(true)
    }
    renderFilterTabIcon(key) {
        return (
            key == "nestedgrid" ?
                <i className="fa fa-list-alt"></i>
                : key == "advancegrid" ?
                    <i className="fa fa-list"></i>
                    : key == "kanban" ?
                        <i className="fa fa-table"></i>
                        : key == "cardgrid" ?
                            <i className="fa fa-th-large"></i>
                            : key == "calender" ?
                                <i className="fa fa-calendar"></i>
                                : key == "map" ?
                                    <i className="fa fa-globe"></i>
                                    : null
        )
    }
    renderFilterButton(FilterUIJson) {
        return (
            <button className={"btn " + (FilterUIJson.applyFilterBtnClass ? FilterUIJson.applyFilterBtnClass : 'btn-outline-primary')}
                onClick={() => { FilterUIJson.CustomFilter ? this.customSearch() : this.search() }}>
                {FilterUIJson.applyFilterBtnIcon != 'none' ?
                    <i className={FilterUIJson.applyFilterBtnIcon + " mr-2"}></i>
                    : null}
                {FilterUIJson.applyFilterBtnText ? FilterUIJson.applyFilterBtnText : 'Apply Filter'}
            </button>
        )
    }
    renderCustomFilter() {
        return (
            this.state.isApiCalling ?
                <div className='sweet-loading isParent'>loading...</div>
                : this.state.customFilterFormUI && this.state.customFilterFormUI.controls ?
                    renderFilterControls(this.state.customFilterFormUI)
                    : null
        )
    }
    renderFilter(FilterUIJson) {
        return (
            <div className='row pt-1'>
                <div className='col pr-0'>
                    {
                        this.renderCustomFilter()
                    }
                </div>
                <div className='col-auto'>
                    <div className="mb-3 d-flex justify-content-between">
                        {this.renderFilterButton(FilterUIJson)}
                    </div>
                </div>
            </div>
        )
    }
    render() {

        const { uiSchema, controls, action, FilterUIJson } = this.state;
        if (action == 'filter') {
            return (
                <React.Fragment>
                    {(renderSearchBox(uiSchema) || !FilterUIJson.hidesearch || !FilterUIJson.hidefilter || FilterUIJson.ShowAddform || FilterUIJson.ShowExport || FilterUIJson.ShowImport) &&
                        <div className='searchbar mb-2'>
                            <div className='row justify-content-end'>
                                <div className="col-auto mx-auto mx-sm-0">
                                    <div className="search-hover d-flex">
                                        <div className="pr-3">
                                            <div className="row renderSearchBox">
                                                {renderSearchBox(uiSchema)}
                                            </div>
                                        </div>
                                        {!FilterUIJson.hidesearch &&
                                            <button aria-label="Search" className={"btn " + (FilterUIJson.searchBtnClass ? FilterUIJson.searchBtnClass : 'btn-outline-secondary')} onClick={(e) => {e.preventDefault(); this.search()}}>
                                                <i className={FilterUIJson.searchBtnIcon ? FilterUIJson.searchBtnIcon : 'fa fa-search'}></i>
                                            </button>
                                        }
                                        {FilterUIJson.enableshoppingcart &&
                                            <button aria-label="Cart" className={"btn " + (FilterUIJson.filterBtnClass ? FilterUIJson.filterBtnClass : 'btn-outline-secondary ml-2')} onClick={(e) => {e.preventDefault();this.handleCartTrayOpen(true)}}>
                                                <span className="bubble-outer">
                                                    <i className='fa fa-shopping-cart'></i>
                                                    {this.state.cartCount > 0 ?
                                                        <span className={"bubble " + FilterUIJson.filterBubble}>{this.state.cartCount}</span>
                                                        : false}
                                                </span>
                                            </button>
                                        }
                                        {!FilterUIJson.hidefilter &&
                                            <button aria-label="Filter" className={"btn " + (FilterUIJson.filterBtnClass ? FilterUIJson.filterBtnClass : 'btn-outline-secondary ml-2')} onClick={(e) => {e.preventDefault();this.handleFilterTrayOpen(true)}}>
                                                <span className="bubble-outer">
                                                    <i className={FilterUIJson.filterBtnIcon ? FilterUIJson.filterBtnIcon : 'fa fa-filter'}></i>
                                                    {this.state.filterCount > 0 ?
                                                        <span className={"bubble " + FilterUIJson.filterBubble}>{this.state.filterCount}</span>
                                                        : false}
                                                </span>
                                            </button>
                                        }
                                        {FilterUIJson.ShowAddform ?
                                            <button aria-label={FilterUIJson.addBtnText ? FilterUIJson.addBtnText.trim() : 'Add New'}  className={"btn " + (FilterUIJson.addBtnClass ? FilterUIJson.addBtnClass : ' ml-2 btn-outline-primary btn-round ')}
                                                onClick={(e) => { e.preventDefault();this.InitializeAddForm(); }}
                                                title={FilterUIJson.addBtnText ? FilterUIJson.addBtnText.trim() : 'Add New'}>
                                                <i className={(FilterUIJson.addBtnIcon ? FilterUIJson.addBtnIcon : ' fa fa-plus ') + " pr-md-1"}></i>
                                                <span className="d-none d-md-inline">{FilterUIJson.addBtnText ? FilterUIJson.addBtnText.trim() : 'Add New'}</span>
                                            </button>
                                            : null}
                                        {FilterUIJson.ShowExport ?
                                            <button aria-label={FilterUIJson.exportBtnText ? FilterUIJson.exportBtnText.trim() : 'Export'} className={"btn " + (FilterUIJson.exportBtnClass ? FilterUIJson.exportBtnClass : 'ml-2 btn-outline-primary btn-round')}
                                                onClick={(e) => { e.preventDefault(); this.exportToCSV(FilterUIJson) }} title="Export">
                                                <i className={(FilterUIJson.exportBtnIcon ? FilterUIJson.exportBtnIcon : 'fa fa-file-excel-o ') + " pr-md-1 "}></i>
                                                <span className="d-none d-md-inline">{FilterUIJson.exportBtnText ? FilterUIJson.exportBtnText.trim() : 'Export'}</span>
                                            </button>
                                            : null}
                                        {FilterUIJson.ShowImport ?
                                            <ImportUI formid={uiSchema.Id + action} control={FilterUIJson} action={action} />
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        <React.Fragment>
                            <Loading token={this.props.token} enable={this.state.isApiCalling === true} class="isParent" loaderClass="override" />
                            {this.renderFilterResult()}
                        </React.Fragment>
                    }
                    <div className={"custom-sidebar-outer sidebar-sm " + (this.state.FilterTrayOpen ? 'sidebar-open' : '')}>
                        <div className="custom-sidebar">
                            <div className="custom-sidebar-header d-flex align-items-center">
                                <button className="btn btn-outline-dark btn-sm" onClick={(e) => {e.preventDefault();this.clearFilter()}}>
                                    Clear Filter
                                        <span className="bubble-outer">
                                        <i className={"fa fa-filter ml-2"}></i>
                                        {this.state.filterCount > 0 ?
                                            <span className={"bubble " + FilterUIJson.filterBubble}>{this.state.filterCount}</span>
                                            : false}
                                    </span>
                                </button>
                                <i className="fa fa-times fa-lg ml-auto" onClick={(() => this.handleFilterTrayOpen(false))}></i>
                            </div>
                            <div className="custom-sidebar-body 2">
                                <div className="container-fluid">
                                    {FilterUIJson && FilterUIJson.CustomFilter ?
                                        this.renderCustomFilter()
                                        :
                                        (
                                            FilterUIJson && Array.isArray(FilterUIJson.controls) && FilterUIJson.controls.map(ctrl => {
                                                return (
                                                    ctrl.type != 'textbox' ?
                                                        <div key={ctrl.id} className="card mb-2">
                                                            <div className="card-header d-flex justify-content-between border-bottom pointer">
                                                                <span>
                                                                    {ctrl.filterheader}
                                                                </span>
                                                                <i className="fa fa-angle-down align-self-center" aria-hidden="true"></i>
                                                            </div>
                                                            {ctrl.filterresult != true && ctrl.addinfilter == true ?
                                                                <div className="card-body py-0 border-bottom">
                                                                    <div className="row">
                                                                        <DynamicFormControls key={ctrl.id} control={ctrl} action={action} />
                                                                    </div>
                                                                </div>
                                                                : null}
                                                        </div>
                                                        : null
                                                )
                                            })
                                        )
                                    }
                                    {this.renderFilterButton(FilterUIJson)}
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <>
                    {FilterUIJson && FilterUIJson.CustomFilter &&
                        this.renderFilter(FilterUIJson)
                    }
                    {FilterUIJson && FilterUIJson.CustomFilter && (this.props.isLoading || this.state.isApiCalling) ? null
                        :
                        <div className="row">
                            {controls.map((control) => {
                                if (!control.filterresult) {
                                    return (
                                        <DynamicFormControls key={control.id} formid={uiSchema.Id} control={control} action={action} />
                                    );
                                }
                            })}
                        </div>
                    }
                </>
            );
        }
    }
}

DynamicForm.contextTypes = {
    history: PropTypes.object
}
DynamicForm.childContextTypes = {
    editFormId: PropTypes.string
};
export default connect(mapStateToProps, bindAction)(DynamicForm);